<i18n>
{
  "de": {
    "submit": "Bestätigen",
    "cancel": "Abbrechen"
  },
  "en": {
    "submit": "Submit",
    "cancel": "Cancel"
  }
}
</i18n>

<template>
  <form
    method="post"
    @submit.prevent="save"
  >
    <div class="editor">
      <section class="container">
        <div
          v-quill:myQuillEditor="editorOption"
          class="quill-editor"
          :editorId="editorId"
          :content="html"
          @change="editorChange($event)"
        />
      </section>

      <div class="editor-form-controls">
        <button
          :disabled="!hasContent"
          :class="{
            hidden: !hasContent,
            'is-small': !isMobileView
          }"
          class="button is-primary"
        >
          {{ $t('submit') }}
        </button>
        <button
          :disabled="!hasContent"
          :class="{
            hidden: !hasContent,
            'is-small': !isMobileView
          }"
          class="button"
          @click.prevent="cancel"
        >
          {{ $t('cancel') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: ['options', 'editorId'],

  data() {
    return {
      html: '',
      command: null,
      editorOption: {
        debug: 'warn',
        ...this.options,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote']
          ],
          clipboard: {
            matchers: [
              [
                '*', (node, delta) => {
                  const ops = []
                  delta.ops.forEach(op => {
                    if (op.insert && typeof op.insert === 'string') {
                      ops.push({
                        insert: op.insert
                      })
                    }
                  })
                  delta.ops = ops
                  return delta
                }
              ]
            ]
          }
        }
      }
    }
  },

  computed: {
    hasContent() {
      const html = this.html.replace(/(<\D>)|()|(<\/\D>)/g, '').trim()
      return html !== ''
    }
  },

  watch: {
    command: function (newCommand) {
      if (newCommand === 'cancel') {
        this.html = ''
      }
    }
  },

  methods: {
    editorChange({ editor, html, text }) {
      this.html = html
      this.command = 'changed'
    },
    cancel() {
      const data = {
        command: 'cancel',
        editorId: this.editorId
      }
      this.html = ''
      this.$emit('editormessage', data)
    },
    save() {
      const data = {
        command: 'save',
        editorId: this.editorId,
        content: this.html
      }
      this.$emit('editormessage', data)
      this.html = ''
    }
  }
}
</script>

<style lang="scss">
@import "assets/sass/_variables";
@import "../node_modules/quill/dist/quill.core.css";
@import "../node_modules/quill/dist/quill.snow.css";

.editor {
  background-color: $white;

  .container {
    padding-bottom: 0;
  }

  .ql-container {
    font-size: 16px;
  }

  .ql-toolbar.ql-snow {
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom-color: $border-color-default;
  }

  .quill-editor.ql-container.ql-snow {
    border-right: none;
    border-bottom: none;
    border-left: none;
  }

  .editor-form-controls {
    min-height: auto;

    .button {
      margin: 0 15px 15px 0;
    }
  }
}

.editor-form-controls {
  display: flex;
  flex-direction: row-reverse;
  min-height: 2em;

  .hidden {
    display: none !important;
  }
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 0 0 10px 0;

  .quill-editor {
    min-height: 100px;
    max-height: 230px;
    overflow-y: auto;
    word-break: break-all;
  }
}
</style>
